import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, LoadableSchema, Transitions } from "../../../types"
import { fetchClassesTransition } from "../transitionalStates"

export const assignClassState: StateNodeConfig<
  Context,
  LoadableSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ assignClassModal: true }),
  exit: assign<Context>({ assignClassModal: false, assignableClasses: [] }),
  initial: "loading",
  states: {
    loading: { ...fetchClassesTransition },
    idle: {
      on: {
        ASSIGN_SUBJECT_TO_CLASSES: {
          target: "#StudyPlan.teacher_view.assign_subject_to_classes_transition"
        }
      }
    }
  },
  on: {
    CLOSE: {
      target: "#StudyPlan.teacher_view.idle"
    }
  }
}
